import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import { PHONE_PATTERN } from '../../format/pieces';
import { s } from '../../format/schema';
import { defineFieldType, formatMessageSetting } from '../card';
import { PhoneNumberInput } from './FillInput';
import { FormatMessageSettingsPanel } from '../shared/FormatMessageSettingsPanel';

export const phoneNumber = defineFieldType({
  type: 'phoneNumber',
  name: 'Phone number',
  valueKind: 'text',
  settings: s.strictObject(formatMessageSetting),
  defaults: {},
  value: s
    .string()
    .refine(text => text === '' || PHONE_PATTERN.test(text), "isn't empty or a phone number: + 7 to 15 digits"),
  emptyValue: '',
  hasDefaultValue: true,
  validations: ['required', 'unique'],
  operators: ['isFilled', 'isEmpty', 'equals', 'notEquals', 'contains', 'notContains', 'startsWith', 'endsWith'],
  palette: [{ name: 'Phone number', tooltip: '+ 7 to 15 digits', group: 'Text', icon: PhoneOutlined }],
  isEmpty: value => value.trim() === '',
  comparable: value => value.replace(/[^\d+]/g, ''),
  builtInCheck: () => 'phoneFormat',
  FillInput: PhoneNumberInput,
  settingsPanel: { at: 'settings', Panel: FormatMessageSettingsPanel },
});
